import { jsx as _jsx } from "react/jsx-runtime";
import { ContentCollectionView, contentCollectionViewSelector } from "@air/feature-content-collection/redux";
import { ContentCollectionCompletedView, ContentCollectionOnboardingView } from "@air/feature-content-collection/ui";
import { useSelector } from "react-redux";
import { ContentCollectionManageView } from "~/components/ContentCollection/ContentCollectionManageView";
export const ContentCollectionViewManager = ()=>{
    const view = useSelector(contentCollectionViewSelector);
    switch(view){
        case ContentCollectionView.Onboarding:
            return /*#__PURE__*/ _jsx(ContentCollectionOnboardingView, {});
        case ContentCollectionView.Manage:
            return /*#__PURE__*/ _jsx(ContentCollectionManageView, {});
        case ContentCollectionView.Completed:
            return /*#__PURE__*/ _jsx(ContentCollectionCompletedView, {});
        default:
            return null;
    }
};
ContentCollectionViewManager.displayName = "ContentCollectionViewManager";
